import {
  Component,
  Event,
  EventEmitter,
  h,
  Host,
  Method,
  Prop,
  State,
} from "@stencil/core";
import wishlistStore, {
  addEntryToNewWishlist,
  addEntryToWishlist,
} from "@stores/wishlist.store";
import config from "../../../../environment/environment-config";
import {
  BcpSelectWishlistModalProps,
  BcpSelectWishlistModalState,
} from "./bcp-select-wishlist-modal-model";
import { AddToWishlistEventDetails } from "../bcp-add-to-wishlist-model";

@Component({
  tag: "bcp-select-wishlist-modal",
})
export class BcpSelectWishlistModal {
  @Prop() addToWishlistUrl: BcpSelectWishlistModalProps["addToWishlistUrl"];

  @Prop() productCode: BcpSelectWishlistModalProps["productCode"];

  @Prop() quantity: BcpSelectWishlistModalProps["quantity"] = 1;

  @Prop()
  headerLabel: BcpSelectWishlistModalProps["headerLabel"] = "Add to wishlist";

  @Prop()
  bodyLabel: BcpSelectWishlistModalProps["bodyLabel"] =
    "Please select the wishlist you want to add the product to";

  @Prop()
  addToNewWishlistLabel: BcpSelectWishlistModalProps["addToNewWishlistLabel"] =
    "+ Add to new wishlist";

  @State()
  selectWishlistDialogVisible: BcpSelectWishlistModalState["selectWishlistDialogVisible"] =
    false;

  @Method()
  async openModal(): Promise<void> {
    await this.dialog.openDialog();
  }

  @Method()
  async closeModal(): Promise<void> {
    await this.dialog.closeDialog();
  }

  @Event() productAddedToWishlist: EventEmitter<AddToWishlistEventDetails>;

  private dialog: HTMLFDialogElement = null;

  render() {
    return (
      <Host>
        <f-dialog
          ref={(el) => (this.dialog = el)}
          headerTitle={this.headerLabel}
          bodyTitle={this.bodyLabel}
          closeIcon={true}
          showDialog={this.selectWishlistDialogVisible}
          withTopBorder={true}
          data-test="select-wishlist-dialog"
        >
          {wishlistStore.wishlists.map((wishlist) => (
            <p>
              <f-button
                onClick={() => {
                  addEntryToWishlist(
                    wishlist.code,
                    this.productCode,
                    this.quantity
                  ).then(() => {
                    this.productAddedToWishlist.emit({
                      productCode: this.productCode,
                      wishlistCode: wishlist.code,
                    });
                  });
                  this.closeModal();
                }}
                variant={"link-simple"}
                data-test="select-wishlist-dialog-select-wishlist-button"
              >
                {wishlist.name}
              </f-button>
            </p>
          ))}
          {(config.wishlistConfig.wishlistsLimit == null ||
            config.wishlistConfig.wishlistsLimit >
              wishlistStore.wishlists.length) && (
            <p>
              <f-button
                onClick={() => {
                  addEntryToNewWishlist(this.productCode, this.quantity).then(
                    (wishlist) => {
                      this.productAddedToWishlist.emit({
                        productCode: this.productCode,
                        wishlistCode: wishlist.code,
                      });
                    }
                  );
                  this.closeModal();
                }}
                variant={"link-simple"}
                data-test="select-wishlist-dialog-new-wishlist-button"
              >
                {this.addToNewWishlistLabel}
              </f-button>
            </p>
          )}
        </f-dialog>
      </Host>
    );
  }
}
